export default "__VITE_ASSET__CzZb4Pdx__"